import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface WorkRequiredScheduleReturn {
  mode: ComputedRef<InputMode>
  label: string
  setWorkRequiredSchedule: (value: boolean) => void
}

export const useWorkRequiredSchedule = (): WorkRequiredScheduleReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Are you ready to work at least 20 hours per week between 4 PM and 8 PM (NEW YORK timezone)?'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && tutorApplicationStore.form.workRequiredSchedule === null))
  
  const setWorkRequiredSchedule = (value: boolean): void => {
    tutorApplicationStore.setField('workRequiredSchedule', value)
  }

  return {
    mode,
    label,
    setWorkRequiredSchedule,
  }
}
